module.exports = __webpack_public_path__ + "static/media/DSC_5954.d923e9a6.jpg";